<form [formGroup]="form">
  <ion-grid class="container-shadow card">
    @if (showOrderMetadata || showOrderType) {
      <ion-row>
        @if (showOrderMetadata) {
          <ion-col size-md="6" size-xs="12">
            <rc-order-user-info
              [order]="orderForNonEditableProperties"
              [subscriptions]="subscriptions"></rc-order-user-info>
          </ion-col>
        }
        @if (showOrderType) {
          <ion-col size-md="6" size-xs="12">
            <rc-order-statuses
              [formGroup]="form"
              [order]="orderForNonEditableProperties"
              alignment="right"
              class="ion-hide-md-down"></rc-order-statuses>
            <rc-order-statuses
              [formGroup]="form"
              [order]="orderForNonEditableProperties"
              alignment="left"
              class="ion-hide-md-up"></rc-order-statuses>
          </ion-col>
        }
      </ion-row>
    }

    @if (showUserSelection) {
      <ion-row>
        <ion-col class="ion-no-padding">
          <rc-user-form-field
            (onValueClick)="user && navigationService.goToUserDetailsPage(user.id)"
            [formControlName]="orderFormFields.userId"
            [initialValue]="user?.id"
            size="medium"></rc-user-form-field>
        </ion-col>
      </ion-row>
    }

    <ion-row>
      <ion-col class="ion-no-padding">
        <rc-location-form-field
          [disablePinchZoom]="disablePinchZoom"
          [formControlName]="orderFormFields.address"
          [initialValue]="orderForNonEditableProperties?.address"
          [showMap]="showMap"
          [zoom]="mapZoom"></rc-location-form-field>
      </ion-col>
    </ion-row>

    @if (showDateDetails) {
      <ion-row>
        <ion-col class="ion-no-padding">
          <rc-date-form-field
            [formControlName]="orderFormFields.fulfillmentDate"
            [initialValue]="orderForNonEditableProperties?.fulfillmentDate"
            size="medium"></rc-date-form-field>
          <rc-order-time-form-field
            [formControlName]="orderFormFields.fulfillmentTime"
            [initialValue]="orderForNonEditableProperties?.fulfillmentTime"
            size="medium"></rc-order-time-form-field>
          @if (form.get(orderFormFields.fulfillmentTime)?.value === "other") {
            <rc-order-time-form-field
              [formControlName]="orderFormFields.fulfillmentTimeOther"
              [useOldOrderTime]="true"
              size="medium"></rc-order-time-form-field>
          }
        </ion-col>
      </ion-row>
    }

    @if (showAccommodations) {
      <ion-row>
        <ion-col class="ion-no-padding">
          <ion-accordion-group class="container-outline">
            <ion-accordion>
              <ion-item class="accordion-header disable-default-style" color="white" slot="header">
                <ion-label class="detail-header">Details</ion-label>
              </ion-item>
              <div class="ion-padding" slot="content">
                <rc-order-preferences-form-field
                  [formControlName]="orderFormFields.preferences"></rc-order-preferences-form-field>
              </div>
            </ion-accordion>
          </ion-accordion-group>
        </ion-col>
      </ion-row>
    }

    @if (showAddToCalender || !showMapByDefault || showDeleteButton) {
      <ion-row class="ion-justify-content-end">
        @if (showAddToCalender) {
          <ion-col class="add-to-calendar-column">
            <rc-add-to-calendar
              (click)="logAddedToCalendar()"
              [items]="items"
              [order]="orderForNonEditableProperties"
              [user]="user"></rc-add-to-calendar>
          </ion-col>
        }
        <ion-col class="ion-text-right">
          @if (showMap && !showMapByDefault) {
            <ion-button (click)="hideMap()">
              <ion-icon name="map-outline"></ion-icon>
            </ion-button>
          }
          @if (!showMap && !showMapByDefault) {
            <ion-button (click)="unhideMap()" color="white">
              <ion-icon name="map-outline"></ion-icon>
            </ion-button>
          }
          @if (showDeleteButton) {
            <ion-button
              (click)="requestDelete()"
              [disabled]="!!orderForNonEditableProperties?.deleteRequested"
              color="white">
              <ion-icon name="trash"></ion-icon>
            </ion-button>
          }
        </ion-col>
      </ion-row>
    }

    @if (showDeleteButton && !!orderForNonEditableProperties?.deleteRequested) {
      <ion-row>
        <ion-col class="ion-no-padding">
          <ion-text class="request-cancel-confirmation">
            Your request to cancel this order has been received by our team, we will respond as soon as possible.
          </ion-text>
        </ion-col>
      </ion-row>
    }
  </ion-grid>
</form>
